module.exports = __webpack_public_path__ + "img/a_gluten.471d66e6.svg";